(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/ground-type-translate/assets/javascripts/ground-type-translate.js') >= 0) return;  svs.modules.push('/components/sport/ground-type-translate/assets/javascripts/ground-type-translate.js'); 
'use strict';

var svs = svs || {};
(function(svs) {

  svs.sport = svs.sport || {};

  svs.sport.GroundTypeTranslate = function GroundTypeTranslate() {
    function _getGroundTypeKey(ground) {
      var val;
      if (ground) {
        val = Array.isArray(ground) ? ground[0] : ground;
        switch (val) {
          case 'hardcourt':
            return svs.statistics.constants.HARDCOURT;
          case 'grus':
            return svs.statistics.constants.GRAVEL;
          case 'gräs':
            return svs.statistics.constants.GRASS;
          default:
            return null;
        }
      }
      return null;
    }

    function fromBetradarToKey(betradarGroundType) {
      var groundType;

      if (typeof betradarGroundType === 'string') {
        groundType = _getGroundTypeKey(
          betradarGroundType.toLowerCase().match('hardcourt|grus|gräs')
        );
      }

      return groundType;
    }

    return {
      fromBetradarToKey: fromBetradarToKey
    };
  };

  if (typeof exports === 'object') {
    module.exports = svs.sport.GroundTypeTranslate;
  }
})(svs);

 })(window);